import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { DocumentsService, Template } from 'src/app/services/documents.service';

@Component({
  selector: 'app-document-template-list',
  templateUrl: './document-template-list.component.html',
  styleUrls: ['./document-template-list.component.scss']
})
export class DocumentTemplateListComponent implements OnInit, OnDestroy {

  public template: Template;
  public templates: Template[];
  @Output() selected: EventEmitter<Template> = new EventEmitter();

  private subscription: Subscription;

  constructor(public documents: DocumentsService) { }

  ngOnInit(): void {
    this.subscription = this.documents.templates.subscribe(templates => {
      this.templates = templates;
    });
  }

  ngOnDestroy(): void {
      this.subscription.unsubscribe();
  }

  selectTemplate(template: Template) {
    this.template = template;
    this.selected.emit(template);
  }
}
